import { render, staticRenderFns } from "./QuickSearch.vue?vue&type=template&id=2f2fb3a9&scoped=true&"
import script from "./QuickSearch.vue?vue&type=script&lang=js&"
export * from "./QuickSearch.vue?vue&type=script&lang=js&"
import style0 from "./QuickSearch.vue?vue&type=style&index=0&id=2f2fb3a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2fb3a9",
  null
  
)

/* custom blocks */
import block0 from "./QuickSearch.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports